import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const SubjectSubscriptions = ({subject, color}) => {
  
    let classColor = "card bg-gradient-" + color;
    let classButton = "primary  bg-gradient-" + color + " border border-0 rounded-pill"

  return (       
    <div className="card99">
      <div className={classColor}>
          <div className="card-body">
            <div className="row ">
                <div className="col centerCard111 ">
                  <span className="h2 font-weight-bold text-white centerCard1"  style={{textTransform: 'capitalize'}}>{subject.tittle}</span>
                  <p className="card-text  navText2" style={{textTransform: 'capitalize'}}>
                    Teacher: {subject.teacherName} 
                    </p>
                </div>
                <div className="col-auto cardIcon">
                  <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                      <i className="ni ni-archive-2 "></i>
                  </div>
                </div>
            </div>
            <p className="mt-3 mb-0 text-sm text-center">
              <LinkContainer to={`/studentplans/${subject._id}`} className='btn btn-default'>
                <Button variant={classButton}> &nbsp; Manage Subscription &nbsp;</Button>
              </LinkContainer>
            </p>
        </div>
      </div>
    </div>
  )
}

export default SubjectSubscriptions
